const initialState = () => ({
  membershipTypes: [],
  jobTypes: [],
  serviceConditions: [],
  existingMembershipMapping: [],
  services: [],

  backScreen: null,
  customFieldMapping: {},
  tagTypeMapping: {},
  jobTypeMappings: [],
  invoiceMappings: [],
  tuneupMappings: [],
  membershipMappings: [],
  loadingTagTypes: false,
  loadingCustomFields: false,
  loadingMappings: false,
});

export default initialState;
